import { useCallback, useEffect } from "react";
import useMosaicEvent from "../events/useMosaicEvent";
import { MosaicEventType } from "../../api/core/types/events";
import ViewerEvent from "../../api/core/ViewerEvent";

export const isMosaicEvent = (e) => e.hasOwnProperty("viewerUUID");

export default function useGlobalEvent<T = Event>(
  eventName: ViewerEvent,
  cb: (evt: T | MosaicEventType) => void
) {
  const eventHandler = useCallback(
    (incomingEvent) => {
      cb(incomingEvent as T);
    },
    [cb]
  );

  useEffect(() => {
    window.addEventListener(eventName, eventHandler);
    return () => {
      window.removeEventListener(eventName, eventHandler);
    };
  }, [eventHandler, eventName]);

  useMosaicEvent(eventName, eventHandler);
}
